module.exports = __webpack_public_path__ + "static/media/albanersee.f3d416e7.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/albanersee.JPG
// module id = 671
// module chunks = 0